import { useState, FormEvent } from 'react'

interface TodoFormProps {
  onSubmit: (text: string) => void
}

const TodoForm = ({ onSubmit }: TodoFormProps) => {
  const [text, setText] = useState('')

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    const trimmedText = text.trim()
    if (!trimmedText) return
    
    onSubmit(trimmedText)
    setText('')
  }

  return (
    <form id="todo-form" onSubmit={handleSubmit}>
      <div className="input-group">
        <input 
          type="text" 
          id="todo-input" 
          placeholder="Add a new task..." 
          value={text}
          onChange={(e) => setText(e.target.value)}
          required
        />
        <button type="submit" id="add-todo-btn">
          <i className="fas fa-plus"></i>
        </button>
      </div>
    </form>
  )
}

export default TodoForm 